import { washProductListItem } from '@/utils/wash.js'

export function washData_indexCase(walkedNode){
  if(walkedNode._type === 'index_case1'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[0] &&
      walkedNode.list[0].list[0].list &&
      walkedNode.list[0].list[0].list[2] &&
      walkedNode.list[0].list[0].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[0].list[2]
      buttonNode.actions = [
        "design",
        "hover",
        "translate"
      ]
    }
  }
  else if(walkedNode._type === 'index_case2'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[2] &&
      walkedNode.list[0].list[1].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[2]
      buttonNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            文字设计: [
              'self_fontFamily',
              'self_textTheme',
              'self_upperLowerCase',
              'self_fontSize',
              'self_color',
              'self_textStyle',
              'self_textAlign',
              'self_textInput'
            ],
            按钮设计: [
              'self_background',
              'self_border',
              'self_margin',
              'self_padding',
              'self_borderRadius',
              'self_transverseMargin',
              'self_shadow'
            ]
          }
        },
        'hover',
        'translate'
      ]
    }
  } else if (walkedNode._type === 'index_case4') {
    washProductListItem(walkedNode, 'item', '4')
  }
  else if(walkedNode._type === 'index_case3'){
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  }
  else if(walkedNode._type === 'index_case4'){
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  }
  else if(walkedNode._type === 'index_case5'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[3] &&
      walkedNode.list[0].list[3].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[3]
      buttonNode.actions = [
        {
          "name": "design",
          "groupLayout": "topBottom",
          "config": {
            "文字设计": [
              "self_fontFamily",
              "self_textTheme",
              "self_fontSize",
              "self_color",
              "self_textStyle",
              "self_textAlign",
              "self_textInput"
            ],
            "按钮设计": [
              "self_background",
              "self_border",
              "self_borderRadius",
              "self_shadow",
              "self_padding",
              "self_margin"
            ]
          }
        },
        "hover",
        "translate"
      ]
    }
  }
  else if(walkedNode._type === 'index_case6'){
    if(
      walkedNode.list &&
      walkedNode.list[0] &&
      walkedNode.list[0].list &&
      walkedNode.list[0].list[1] &&
      walkedNode.list[0].list[1].list &&
      walkedNode.list[0].list[1].list[2] &&
      walkedNode.list[0].list[1].list[2].componentName === 'button_text'
    ){
      var buttonNode = walkedNode.list[0].list[1].list[2]
      buttonNode.actions = [
        "design",
        "hover",
        "translate"
      ]
    }
  }
}